import React, { useCallback, useEffect, useState } from "react";
import HeaderDashboard from "../../../components/layout/header/HeaderDashboard";
import { FaShieldAlt } from "react-icons/fa";
import "../tcGuaranteeStep.scss";
import { agreementMailPages, identityText } from "../../../locales/en";
import OnboardingIdentityInfoModal from "../../../components/modals/OnboardingIdentityInfoModal";
import { Link, useSearchParams } from "react-router-dom";
import {
  getAcceptCreditConsentTokenUrl,
  getAplayIdRedirectWebTokenURL,
  getCheckStatusTokenURL,
  getCheckTokenValidityUrl
} from "../../../utils/constants/apiEndPoints";
import publicAxios from "../../../utils/publicAxios";
import { QRCodeCanvas } from "qrcode.react";
import OnboardingIdentityTokenModal from "../../../components/modals/OnboardingIdentityTokenModal";
import { showToast } from "../../../utils/utils";
import { showToastType } from "../../../utils/constants/appConstants";

const BiometricIdVerification = () => {
  const [searchParams] = useSearchParams();
  const [infoModal, setInfoModal] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [getToken, setToken] = useState("");
  const [qrUrl, setQrUrl] = useState("");
  const [mobileLink, setMobileLink] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [isExpired, setIsExpired] = useState(false);

  const CheckTokenValidity = useCallback(async () => {
    try {
      const response = await publicAxios.get(getCheckTokenValidityUrl, {
        params: { token: getToken }
      });

      setIsExpired(response.data.data.isUsed);
    } catch (error) {
      showToast(error.response?.data?.message, showToastType.error);
    }
  }, [getToken]);

  const handleQrScanFunction = useCallback(async () => {
    try {
      const response = await publicAxios.post(
        getAplayIdRedirectWebTokenURL,
        {},
        {
          params: {
            token: getToken
          }
        }
      );
      const result = response?.data?.data;
      if (result?.status) {
        const redirectUrl = result?.start_process_url;
        setQrUrl(redirectUrl);
      }
    } catch {
      // handle catch here;
    }
  }, [getToken]);

  const checkStatusFunc = useCallback(async () => {
    try {
      const response = await publicAxios.get(getCheckStatusTokenURL, {
        params: {
          token: getToken
        }
      });
      const result = response?.data?.data;
      if (result?.status === true) {
        setSuccessMsg(true);
      }
    } catch {
      // handle catch here;
    }
  }, [getToken]);

  const handleCheckboxChange = async (e) => {
    const { checked } = e.target;
    setIsChecked(checked);

    try {
      await publicAxios.post(
        getAcceptCreditConsentTokenUrl,
        {},
        {
          params: {
            acceptConsent: checked,
            token: getToken
          }
        }
      );
    } catch (error) {
      showToast(error.response.data.message, showToastType.error);
    }
  };

  const handleInfoModal = () => {
    setInfoModal(!infoModal);
  };

  const handleOpenSendLink = () => {
    setMobileLink(!mobileLink);
  };

  useEffect(() => {
    if (getToken) checkStatusFunc();

    const interval = setInterval(() => {
      if (getToken) checkStatusFunc();
    }, 20000);

    return () => clearInterval(interval);
  }, [getToken, checkStatusFunc]);

  useEffect(() => {
    const token = searchParams.get("token");
    setToken(token);
  }, [searchParams]);

  useEffect(() => {
    if (getToken) {
      handleQrScanFunction();
    }
  }, [getToken, handleQrScanFunction]);

  useEffect(() => {
    if (getToken) CheckTokenValidity();
  }, [getToken]);

  return (
    <>
      <div className="customStep">
        <HeaderDashboard />

        {isExpired === false ? (
          <div className="container">
            <div className="mainAreaBox mb-5">
              <div className="top_icon_part">
                <div className="circleIcon">
                  <FaShieldAlt />
                </div>
                <div className="circletitle">
                  {agreementMailPages?.biometricIDverification.title}
                </div>
              </div>
              {successMsg ? (
                <div
                  className="text-center alert alert-success mt-5"
                  role="alert"
                >
                  {agreementMailPages?.idOnly.completed}
                </div>
              ) : (
                <>
                  <div className="checkPart checkbox mt-5">
                    <div className="d-flex align-items-center justify-content-center">
                      <input
                        name="kycIdentity"
                        type="checkbox"
                        id="kyc-consent"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                      />
                      <label htmlFor="kyc-consent">
                        {`${identityText?.useAdditionalComp.iConsent} `}
                        <Link onClick={handleInfoModal}>
                          {identityText?.useAdditionalComp.creditandUdentity}
                        </Link>
                      </label>
                    </div>
                  </div>

                  {isChecked && (
                    <div className="qrCodePart mt-4">
                      <p>{identityText?.useAdditionalComp.pleaseScan}</p>
                      <div className="qrImg">
                        <QRCodeCanvas
                          value={qrUrl}
                          size={250}
                          bgColor="#ffffff"
                          fgColor="#000000"
                          level="H"
                        />
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary mt-3 mb-4"
                        onClick={handleOpenSendLink}
                      >
                        {agreementMailPages?.biometricIDverification.submitbtn}
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        ) : (
          <div className="row">
            <div className="col-12">
              <div className="expired-token-message text-center pt-5">
                <h3>{identityText?.tokenExpiredText}</h3>
              </div>
            </div>
          </div>
        )}
      </div>

      <OnboardingIdentityInfoModal
        isOpen={infoModal}
        toggle={handleInfoModal}
      />

      <OnboardingIdentityTokenModal
        isOpen={mobileLink}
        getToken={getToken}
        toggle={handleOpenSendLink}
        successMsg={successMsg}
      />
    </>
  );
};

export default BiometricIdVerification;
